import { v4 } from 'uuid';

export const DataUtils = {
  uuid: (): string => {
    if (self.crypto.randomUUID) {
      return self.crypto.randomUUID();
    } else {
      return v4();
    }
  },
};
